import React from "react";

function NavBar1() {
  return (
    <div>
      <nav className="navbar navbar-dark bg-dark">
        <div className="container-fluid d-flex justify-content-center">
          <a className="navbar-brand" href="/">
            <strong> </strong>
          </a>
        </div>
      </nav>
    </div>
  );
}

export default NavBar1;